import React, { useState } from 'react';
import { LucideIcon } from 'lucide-react';

interface ProcessCardProps {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
  hasAIAction?: boolean;
}

export const ProcessCard: React.FC<ProcessCardProps> = ({ number, title, description, icon: Icon, hasAIAction }) => {
  const [loading, setLoading] = useState(false);
  const [hook, setHook] = useState<string | null>(null);

  const handleGenerateHook = async () => {
    setLoading(true);
    setTimeout(() => {
      setHook("POV: You found the secret level 🤫");
      setLoading(false);
    }, 1500);
  };

  return (
    <div className="h-full flex flex-col justify-between min-h-[180px]">
      <div className="flex justify-between items-start mb-6">
        <div className="p-2.5 bg-zinc-800/50 rounded-xl text-primary border border-zinc-700/50">
          <Icon size={20} />
        </div>
        <span className="text-zinc-700 font-mono text-xs font-bold tracking-widest opacity-60">{number}</span>
      </div>
      
      <div className="flex flex-col flex-grow justify-between">
        <div className="mb-4">
          <h3 className="text-lg font-bold text-zinc-100 mb-2">{title}</h3>
          <p className="text-zinc-400 text-sm leading-relaxed line-clamp-3">{description}</p>
        </div>
        
        {hasAIAction && (
          <div className="mt-auto pt-2">
             {!hook ? (
               <button 
                onClick={handleGenerateHook}
                disabled={loading}
                className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-zinc-800/80 hover:bg-zinc-700 rounded-lg text-xs font-medium text-zinc-300 transition-colors border border-zinc-700/50"
              >
                {loading ? "Generating..." : "Generate AI Hook"}
              </button>
             ) : (
               <div className="w-full bg-zinc-900/90 p-3 rounded-lg border border-primary/20 animate-in fade-in slide-in-from-bottom-2 duration-300">
                 <p className="text-xs text-zinc-300 italic mb-1">"{hook}"</p>
                 <button onClick={() => setHook(null)} className="text-[10px] text-zinc-500 hover:text-primary transition-colors block ml-auto">Reset</button>
               </div>
             )}
          </div>
        )}
      </div>
    </div>
  );
};
